<template>
  <div v-if="currentReport" class="report-window-wrapper" :class="{iframe: !openDocInNewTab}">
    <vue-headful :title="`View Report - ${currentReport.title}`" />

    <v-layout
      v-if="openDocInNewTab"
      id="report-window-ios"
      align-center
      fill-height
      justify-center>
        <v-btn
          :href="`${currentReport.link}?noheader=true`"
          color="info"
          large
          target="_blank">
          <v-icon left dark>description</v-icon> Open PDF
        </v-btn>
    </v-layout>
    <div v-else class="report-window-scroller" id="report-window-iframe">
      <iframe
        :src="`${currentReport.link}?noheader=true`"
        :title="currentReport.title"
        allowfullscreen
        class="report-window" />
    </div>
  </div>
</template>

<script>
import { detect } from 'detect-browser';
import { mapState } from 'vuex';

import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';

export default {
  extends: BaseViewComponent,
  mounted() {
    this.initialHydration([
      this.$store.dispatch('Inspection/loadInspection', this.folderId),
    ]);
  },
  props: {
    folderId: {
      type: String,
      required: true,
    },
    reportId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    currentReport() {
      const reports = this.inspection.reports || [];
      return reports.find(report => report.id.toString() === this.reportId);
    },
    isIosDevice() {
      const browser = detect();
      if (browser) {
        return browser.os === 'iOS';
      }
      return false;
    },
    isPdfReport() {
      if (this.currentReport) {
        const regex = /\w+\.pdf(?=\?|$)/gi;
        const isPdf = regex.exec(this.currentReport.link);
        return !!isPdf;
      }
      return false;
    },
    openDocInNewTab() {
      return this.isIosDevice && this.isPdfReport;
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (!to.hash) { /* ignore anchor tags for scrolling */
      this.mounted();
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.report-window-wrapper {
  height: 100%;
  position: relative;
  width: 100%;

  &.iframe {
    height: 80vh;
  }
}

/*
  use parent container as iframe sizing element
  to override potential block element issues
*/
.report-window-scroller {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-overflow-scrolling: touch;

  iframe {
    border: none;
    height: 100%;
    width: 100%;
  }
}

@media all and (max-width: 655px) {
  .report-window-wrapper {
    width: 100vw;
  }

  .report-list {
    flex-direction: column;
    margin-left: 30px;
  }
}
</style>
